import React, { PropTypes } from 'react';
import classNames from 'classnames';
import AdContainer from './AdContainer';

const InContentAd = (props) => {
    const className = classNames('ad-slot-incontent ad-wrapper', props.adClassName);
    return (
        <AdContainer
            className={className}
            slotType="incontent"
            kvps={{ pos: 'incontent' }}
            render={InContentAd.render}
            {...props}
        />
    );
};

// This pattern is for AdContainer to give control to disable ads based on global state
InContentAd.render = (children) => (
    <div className="ad-wrapper">
        <article className="ad-300">
            <div className="ad-center">
                {children}
            </div>
        </article>
    </div>
);

InContentAd.propTypes = {
    adClassName: PropTypes.string
};

export default InContentAd;



// WEBPACK FOOTER //
// ./app/common/ads/InContentAd.js